import { useGetCustomerConfigurations } from 'api';

import { useOrganisationId } from 'hooks/context';

export type CryptoProvider = 'layer1' | 'c2c';

export const useCryptoProvider = () => {
  const organisationId = useOrganisationId<number>();

  const { data: { data: orgSettings } = {}, isLoading } =
    useGetCustomerConfigurations(organisationId);

  const cryptoProvider = orgSettings?.crypto_provider as
    | CryptoProvider
    | undefined;

  return { cryptoProvider, isC2c: cryptoProvider === 'c2c', isLoading };
};
